"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LoadingPage = function LoadingPage(_ref) {
  var background = _ref.background,
    spinColor = _ref.spinColor,
    $bsStyle = _ref.$bsStyle;
  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    background: background,
    $bsStyle: $bsStyle,
    spinColor: spinColor
  }, /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    type: "TailSpin",
    color: spinColor,
    height: 80,
    width: 80
  }));
};
LoadingPage.propTypes = {
  background: _propTypes.default.string,
  spinColor: _propTypes.default.string,
  $bsStyle: _propTypes.default.shape({})
};
LoadingPage.defaultProps = {
  background: null,
  spinColor: 'rgb(92, 92, 92)',
  $bsStyle: undefined
};
var _default = LoadingPage;
exports.default = _default;